exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nd-send-code[data-v-662c5c21] {\n  height: 0.56rem;\n  line-height: 0.56rem;\n  text-align: center;\n}\n.nd-send-code.disabled[data-v-662c5c21] {\n  color: #AAAAAA;\n  background-color: #FAFAFA;\n}\n.nd-send-code.un-disabled[data-v-662c5c21] {\n  color: #994B24;\n  background-color: #FDF5DF;\n}\n.nd-send-code span[data-v-662c5c21] {\n  line-height: 0.56rem;\n  font-size: 0.293333rem;\n  white-space: nowrap;\n}", ""]);

// exports
